import type { InteractionType } from '@cult/domain';
import clsx from 'clsx';
import styles from './InteractionTypeBadge.module.scss';
import { INTERACTION_TYPE_META } from './interaction-type-meta';

export const InteractionTypeBadge = ({ type }: { type: InteractionType }) => {
  const { label, icon, toneClassName } = INTERACTION_TYPE_META[type];

  return (
    <span className={clsx(styles.badge, toneClassName)}>
      {icon}
      {label}
    </span>
  );
};
